import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="136"
      height="48"
      viewBox="0 0 352 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5308 128 16.1458 128 18.7608 128C123.587 128 228.413 128 333.239 128C335.854 128 338.469 128 341.084 128C342.589 128 344.094 128 345.598 128C346.103 128.001 346.59 127.944 347.081 127.827C347.316 127.77 347.548 127.7 347.776 127.618C348.696 127.284 349.448 126.806 350.139 126.11C350.236 126.013 350.329 125.912 350.419 125.809C350.534 125.678 350.643 125.542 350.746 125.402C350.753 125.392 350.761 125.382 350.768 125.372C351.015 125.033 351.225 124.679 351.401 124.299C351.409 124.283 351.416 124.266 351.424 124.249C351.432 124.232 351.439 124.215 351.447 124.198C351.455 124.182 351.462 124.164 351.469 124.147C351.491 124.096 351.513 124.044 351.534 123.993C351.538 123.981 351.544 123.968 351.549 123.956C351.645 123.712 351.725 123.465 351.792 123.212C351.794 123.203 351.796 123.195 351.799 123.186C351.932 122.662 351.998 122.141 351.998 121.6C351.998 117.333 351.998 113.067 351.998 108.799C351.998 74.6665 351.998 40.5336 351.998 6.40019C351.998 2.86566 349.133 0 345.598 0C344.094 0 342.589 0 341.084 0C339.869 0 338.654 0 337.439 0C337.405 0 337.372 0 337.337 0C337.287 0 337.238 0 337.188 0C335.871 0 334.554 0 333.238 0C228.412 0 123.585 0 18.7603 0C17.4435 0 16.1272 0 14.8109 0C14.7613 0 14.711 0 14.6613 0C14.6275 0 14.5936 0 14.5592 0C13.3445 0 12.1292 0 10.9146 0C9.40975 0 7.90499 0 6.40019 0C2.86566 0 0 2.86566 0 6.40019C0 40.5336 0 74.6665 0 108.799C0 113.067 0 117.333 0 121.6C0 125.134 2.86566 128 6.40019 128C7.90612 128 9.41092 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86631 127.999 6.40196 127.999C7.90676 127.999 9.41159 127.999 10.9164 127.999C13.5314 127.999 16.1465 127.999 18.761 127.999C48.9213 127.999 191.08 127.999 221.24 127.999C223.856 127.999 338.47 127.999 341.085 127.999C342.59 127.999 344.095 127.999 345.6 127.999C346.104 128.001 346.591 127.943 347.081 127.826C347.318 127.77 347.549 127.7 347.777 127.618C348.697 127.284 349.45 126.805 350.139 126.11C350.236 126.013 350.33 125.912 350.42 125.809C350.849 125.318 351.185 124.793 351.448 124.198C351.456 124.182 351.463 124.164 351.471 124.147C351.602 123.842 351.709 123.532 351.793 123.211C351.795 123.202 351.797 123.194 351.799 123.185C351.934 122.661 351.999 122.14 351.999 121.599C351.999 117.332 351.999 113.066 351.999 108.799C351.999 108.666 351.999 108.532 351.999 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6152_23536)"
      />
      <path
        opacity="0.2"
        d="M19.6007 0C19.3207 0 19.0408 0 18.7608 0C17.4445 0 16.1277 0 14.8114 0C14.7618 0 14.7115 0 14.6618 0C14.628 0 14.5941 0 14.5602 0C13.345 0 12.1298 0 10.9151 0C9.41031 0 7.90548 0 6.40068 0C2.86559 0 0.000488281 2.86566 0.000488281 6.40019C0.000488281 40.5336 0.000488281 74.666 0.000488281 108.799C0.000488281 113.067 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86559 127.999 6.40068 127.999C7.90548 127.999 9.41031 127.999 10.9151 127.999C13.5302 127.999 16.1457 127.999 18.7602 127.999C19.0402 127.999 19.3202 127.999 19.6001 127.999V0H19.6007Z"
        fill="url(#paint1_linear_6152_23536)"
      />
      <path
        opacity="0.2"
        d="M332.399 0C332.679 0 332.959 0 333.239 0C334.556 0 335.872 0 337.189 0C337.238 0 337.288 0 337.338 0C337.372 0 337.406 0 337.44 0C338.655 0 339.87 0 341.085 0C342.59 0 344.095 0 345.599 0C349.134 0 351.999 2.86566 351.999 6.40019C351.999 40.5336 351.999 74.666 351.999 108.799C351.999 113.067 351.999 117.333 351.999 121.6C351.999 125.134 349.134 127.999 345.599 127.999C344.095 127.999 342.59 127.999 341.085 127.999C338.47 127.999 335.854 127.999 333.239 127.999C332.959 127.999 332.68 127.999 332.4 127.999V0H332.399Z"
        fill="url(#paint2_linear_6152_23536)"
      />
      <path
        d="M243.855 19.6001C243.675 19.6001 243.6 19.6752 243.6 19.8563C243.6 49.2857 243.6 78.7151 243.6 108.145C243.6 108.325 243.675 108.4 243.855 108.4C273.285 108.4 302.714 108.4 332.143 108.4C332.324 108.4 332.399 108.325 332.399 108.145C332.399 78.7151 332.399 49.2857 332.399 19.8563C332.399 19.6752 332.324 19.6001 332.143 19.6001C302.714 19.6001 273.285 19.6001 243.855 19.6001Z"
        fill="#575756"
      />
      <path
        d="M331.999 107.744C331.999 107.924 331.924 107.999 331.743 107.999C302.58 107.999 273.418 107.999 244.255 107.999C244.075 107.999 244 107.924 244 107.744C244 78.5814 244 49.4184 244 20.2559C244 20.0753 244.075 20.0002 244.255 20.0002C273.418 20.0002 302.58 20.0002 331.743 20.0002C331.924 20.0002 331.999 20.0753 331.999 20.2559C331.999 49.4184 331.999 78.5814 331.999 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M243.855 19.6001C243.675 19.6001 243.6 19.6752 243.6 19.8563C243.6 49.2857 243.6 78.7151 243.6 108.145C243.6 108.325 243.675 108.4 243.855 108.4C273.285 108.4 302.714 108.4 332.143 108.4C332.324 108.4 332.399 108.325 332.399 108.145C332.399 78.7151 332.399 49.2857 332.399 19.8563C332.399 19.6752 332.324 19.6001 332.143 19.6001C302.714 19.6001 273.285 19.6001 243.855 19.6001Z"
        fill="#575756"
      />
      <path
        d="M331.999 107.744C331.999 107.924 331.924 107.999 331.743 107.999C302.58 107.999 273.418 107.999 244.255 107.999C244.075 107.999 244 107.924 244 107.744C244 78.5814 244 49.4184 244 20.2559C244 20.0753 244.075 20.0002 244.255 20.0002C273.418 20.0002 302.58 20.0002 331.743 20.0002C331.924 20.0002 331.999 20.0753 331.999 20.2559C331.999 49.4184 331.999 78.5814 331.999 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M243.857 19.5999C243.676 19.5999 243.601 19.6749 243.601 19.8561C243.601 49.2856 243.601 78.7146 243.601 108.144C243.601 108.325 243.676 108.4 243.857 108.4C273.287 108.4 302.715 108.4 332.145 108.4C332.327 108.4 332.401 108.325 332.401 108.144C332.401 78.7146 332.401 49.2856 332.401 19.8561C332.401 19.6749 332.327 19.5999 332.145 19.5999C302.716 19.5999 273.287 19.5999 243.857 19.5999Z"
        fill="#575756"
      />
      <path
        d="M331.745 20.2557V20H244.258"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M331.745 20C331.926 20 332.001 20.0751 332.001 20.2557C332.001 49.4188 332.001 78.5814 332.001 107.744C332.001 107.925 331.926 108 331.745 108C302.582 108 273.42 108 244.257 108C244.077 108 244.001 107.925 244.001 107.744C244.001 78.5814 244.001 49.4188 244.001 20.2557C244.001 20.0751 244.077 20 244.257 20"
        fill="#E3E3E3"
      />
      <path
        d="M288.001 94.8798C305.056 94.8798 318.881 81.0545 318.881 64.0002C318.881 46.9459 305.056 33.1206 288.001 33.1206C270.947 33.1206 257.122 46.9459 257.122 64.0002C257.122 81.0545 270.947 94.8798 288.001 94.8798Z"
        fill="url(#paint3_linear_6152_23536)"
      />
      <path
        d="M272.641 68.5597C275.16 68.5597 277.201 66.5181 277.201 63.9996C277.201 61.4811 275.16 59.4395 272.641 59.4395C270.123 59.4395 268.081 61.4811 268.081 63.9996C268.081 66.5181 270.123 68.5597 272.641 68.5597Z"
        fill="#3C3C3B"
      />
      <path
        d="M303.362 68.5597C305.88 68.5597 307.922 66.5181 307.922 63.9996C307.922 61.4811 305.88 59.4395 303.362 59.4395C300.843 59.4395 298.802 61.4811 298.802 63.9996C298.802 66.5181 300.843 68.5597 303.362 68.5597Z"
        fill="#3C3C3B"
      />
      <path
        d="M320.67 98.0235C320.258 98.4361 320.258 99.1061 320.67 99.5193C321.084 99.933 321.751 99.9308 322.165 99.5182C322.578 99.1061 322.579 98.4361 322.166 98.0235C321.753 97.6103 321.084 97.6103 320.67 98.0235Z"
        fill="#575756"
      />
      <path
        d="M317.655 98.2911C316.923 98.2911 316.191 98.2911 315.459 98.2911C315.33 98.2905 315.277 98.2375 315.277 98.1093C315.277 96.3438 315.277 94.5788 315.277 92.8138C315.277 92.6845 315.33 92.632 315.459 92.632C317.224 92.632 318.989 92.632 320.754 92.632C320.883 92.632 320.935 92.6851 320.936 92.8138C320.936 93.5458 320.936 94.2785 320.936 95.0111C320.936 95.3509 321.076 95.4914 321.416 95.4914C321.755 95.4914 321.896 95.3509 321.896 95.0111C321.896 94.2785 321.896 93.5458 321.896 92.8138C321.895 92.1833 321.384 91.673 320.755 91.6719C318.99 91.6719 317.225 91.6719 315.46 91.6719C314.829 91.6724 314.318 92.1833 314.318 92.8138C314.318 94.5788 314.318 96.3438 314.318 98.1093C314.318 98.7393 314.829 99.2506 315.46 99.2512C316.192 99.2512 316.924 99.2512 317.656 99.2512C317.994 99.2512 318.136 99.1107 318.136 98.7709C318.136 98.4311 317.993 98.2911 317.655 98.2911Z"
        fill="#575756"
      />
      <path
        d="M291.122 41.6003V33.2878C290.09 33.1822 289.05 33.1201 288.002 33.1201C286.949 33.1201 285.908 33.1737 284.882 33.2765V41.5998H291.122V41.6003Z"
        fill="#3C3C3B"
      />
      <path
        d="M261.601 59.3103C261.601 55.5313 261.601 51.7518 261.601 47.9734C259.456 51.4995 258.005 55.4924 257.419 59.7601C258.663 59.7601 259.907 59.7601 261.151 59.7601C261.469 59.7595 261.601 59.6286 261.601 59.3103Z"
        fill="#D0D0D0"
      />
      <path
        d="M314.895 59.7595C316.126 59.7595 317.358 59.7595 318.589 59.7595C318.581 59.7065 318.574 59.6534 318.566 59.5998C318.558 59.5468 318.551 59.4931 318.543 59.4401C317.954 55.4924 316.723 51.9742 314.722 48.5203C314.62 48.3459 314.505 48.1794 314.402 48.0078C314.402 51.7602 314.402 55.5144 314.402 59.2668C314.402 59.6156 314.546 59.7595 314.895 59.7595Z"
        fill="#D0D0D0"
      />
      <path
        d="M284.881 86.3999V94.7232C285.908 94.8259 286.948 94.8795 288.001 94.8795C289.054 94.8795 290.095 94.8254 291.121 94.7232V86.3999H284.881Z"
        fill="#3C3C3B"
      />
      <path
        d="M261.075 68.2395C259.856 68.2395 258.637 68.2395 257.418 68.2395C258.005 72.5084 259.455 76.5001 261.601 80.0268C261.601 76.2732 261.601 72.5203 261.601 68.7667C261.601 68.3936 261.447 68.2395 261.075 68.2395Z"
        fill="#D0D0D0"
      />
      <path
        d="M315.013 68.2395C314.581 68.2395 314.402 68.419 314.402 68.8508C314.402 72.5767 314.402 76.3014 314.402 80.0268C316.547 76.5001 317.998 72.5084 318.584 68.2395C317.394 68.2395 316.203 68.2395 315.013 68.2395Z"
        fill="#D0D0D0"
      />
      <path
        d="M286.104 94.809C286.734 94.8502 287.366 94.8795 288.001 94.8795C288.639 94.8795 289.27 94.8536 289.898 94.8152V85.271H286.104V94.809H286.104Z"
        fill="url(#paint4_linear_6152_23536)"
      />
      <path
        d="M289.899 33.1904C289.269 33.1492 288.637 33.1199 288.002 33.1199C287.364 33.1199 286.733 33.1458 286.105 33.1842V42.7284H289.899V33.1904H289.899Z"
        fill="url(#paint5_linear_6152_23536)"
      />
      <path
        d="M220.399 107.744C220.399 107.924 220.324 107.999 220.143 107.999C190.981 107.999 161.818 107.999 132.656 107.999C132.475 107.999 132.4 107.924 132.4 107.744C132.4 78.5814 132.4 49.4184 132.4 20.2559C132.4 20.0753 132.475 20.0002 132.656 20.0002C161.818 20.0002 190.981 20.0002 220.143 20.0002C220.324 20.0002 220.399 20.0753 220.399 20.2559C220.399 49.4184 220.399 78.5814 220.399 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M132.256 20C132.075 20 132 20.075 132 20.2556C132 49.685 132 79.1139 132 108.543C132 108.724 132.075 108.8 132.256 108.8C161.685 108.8 191.114 108.8 220.543 108.8C220.724 108.8 220.799 108.724 220.799 108.543C220.799 79.1139 220.799 49.685 220.799 20.2556C220.799 20.075 220.724 20 220.543 20C191.114 20 161.685 20 132.256 20Z"
        fill="#575756"
      />
      <path
        d="M220.4 108.143C220.4 108.324 220.325 108.399 220.143 108.399C190.981 108.399 161.818 108.399 132.656 108.399C132.475 108.399 132.4 108.324 132.4 108.143C132.4 78.9806 132.4 49.8182 132.4 20.6558C132.4 20.4751 132.475 20.4001 132.656 20.4001C161.818 20.4001 190.981 20.4001 220.143 20.4001C220.325 20.4001 220.4 20.4751 220.4 20.6558C220.4 49.8182 220.4 78.9806 220.4 108.143Z"
        fill="#E3E3E3"
      />
      <path
        d="M207.338 98.691C205.879 98.691 204.421 98.691 202.962 98.691C203.052 97.8268 203.143 96.9628 203.234 96.0992C203.429 94.2371 206.137 94.0689 206.504 95.9112C206.589 96.3227 207.124 96.439 207.367 96.0946C207.442 95.9885 207.467 95.8892 207.452 95.7599C207.419 95.4969 207.326 95.2688 207.208 95.0385C206.818 94.2788 206.313 93.9147 205.489 93.7273C203.907 93.3678 202.45 94.3741 202.279 95.9986C202.17 97.0394 202.059 98.0803 201.95 99.1205C201.912 99.4874 202.058 99.6507 202.428 99.6507C202.933 99.6507 203.436 99.6507 203.94 99.6507C203.988 100.905 205.778 100.905 205.824 99.6507C206.33 99.6507 206.833 99.6507 207.337 99.6507C207.677 99.6507 207.818 99.5101 207.818 99.1703C207.818 98.8305 207.677 98.691 207.338 98.691Z"
        fill="#575756"
      />
      <path
        d="M209.15 89.792C208.866 89.6069 208.671 89.647 208.486 89.9315C208.3 90.2154 208.341 90.4101 208.625 90.5958C210.297 91.6875 211.135 92.9596 211.526 94.9103C211.592 95.2428 211.757 95.3534 212.09 95.2868C212.423 95.2196 212.533 95.0543 212.467 94.7218C212.061 92.6904 210.891 90.9277 209.15 89.792Z"
        fill="#575756"
      />
      <path
        d="M197.3 94.7218C197.233 95.0543 197.344 95.2202 197.676 95.2868C198.009 95.3534 198.174 95.2433 198.241 94.9103C198.63 92.9596 199.47 91.6869 201.141 90.5958C201.425 90.4101 201.466 90.2154 201.281 89.9315C201.095 89.647 200.901 89.6063 200.616 89.792C198.875 90.9277 197.705 92.6904 197.3 94.7218Z"
        fill="#575756"
      />
      <path
        d="M199.844 95.0657C199.767 95.3964 199.875 95.5624 200.204 95.6414C200.535 95.7204 200.703 95.6127 200.779 95.2819C201.054 94.1011 201.581 93.3311 202.619 92.6905C202.907 92.5121 202.952 92.3179 202.773 92.0295C202.595 91.7399 202.402 91.6948 202.113 91.8749C200.832 92.6628 200.18 93.6094 199.844 95.0657Z"
        fill="#575756"
      />
      <path
        d="M207.654 91.8748C207.365 91.6953 207.171 91.741 206.992 92.0289C206.814 92.3179 206.859 92.511 207.147 92.6905C208.186 93.3311 208.715 94.0981 208.986 95.2812C209.062 95.6119 209.231 95.7164 209.562 95.6419C209.894 95.5663 209.998 95.3969 209.923 95.0662C209.587 93.6077 208.93 92.665 207.654 91.8748Z"
        fill="#575756"
      />
      <path
        d="M158.946 62.6726C156.619 62.6732 156.582 66.1118 158.908 66.1637C161.234 66.2156 161.274 62.6732 158.946 62.6726Z"
        fill="#3C3C3B"
      />
      <path
        d="M176.4 80.1089C174.073 80.1089 174.035 83.5481 176.362 83.5994C178.688 83.6508 178.727 80.1089 176.4 80.1089Z"
        fill="#3C3C3B"
      />
      <path
        d="M171.964 57.4371C171.964 55.1099 171.964 52.7827 171.964 50.4555C171.964 49.4909 171.182 48.7097 170.219 48.7097C169.254 48.7097 168.472 49.4909 168.472 50.4555C168.472 52.7827 168.472 55.1099 168.472 57.4371C168.472 58.4006 169.254 59.1823 170.219 59.1823C171.182 59.1823 171.964 58.4006 171.964 57.4371Z"
        fill="#3C3C3B"
      />
      <path
        d="M190.508 74.8726C190.508 72.5454 190.508 70.2183 190.508 67.8911C190.508 66.927 189.726 66.1453 188.762 66.1453C187.798 66.1453 187.016 66.927 187.016 67.8911C187.016 70.2183 187.016 72.5454 187.016 74.8726C187.016 75.8367 187.798 76.6184 188.762 76.6184C189.727 76.6179 190.508 75.8367 190.508 74.8726Z"
        fill="#3C3C3B"
      />
      <path
        d="M165.783 74.8726C165.783 72.5454 165.783 70.2183 165.783 67.8911C165.783 66.927 165.001 66.1453 164.038 66.1453C163.073 66.1453 162.292 66.927 162.292 67.8911C162.292 70.2183 162.292 72.5454 162.292 74.8726C162.292 75.8367 163.073 76.6184 164.038 76.6184C165.001 76.6179 165.783 75.8367 165.783 74.8726Z"
        fill="#3C3C3B"
      />
      <path
        d="M184.327 57.4371C184.327 55.1099 184.327 52.7827 184.327 50.4555C184.327 49.4909 183.545 48.7097 182.581 48.7097C181.617 48.7097 180.835 49.4909 180.835 50.4555C180.835 52.7827 180.835 55.1099 180.835 57.4371C180.835 58.4006 181.617 59.1823 182.581 59.1823C183.545 59.1823 184.327 58.4006 184.327 57.4371Z"
        fill="#3C3C3B"
      />
      <path
        d="M187.017 53.9267C187.017 56.2539 187.017 58.581 187.017 60.9082C187.017 61.8728 187.798 62.654 188.763 62.654C189.726 62.654 190.508 61.8728 190.508 60.9082C190.508 58.581 190.508 56.2539 190.508 53.9267C190.508 52.9632 189.726 52.1814 188.763 52.1814C187.798 52.1814 187.017 52.9632 187.017 53.9267Z"
        fill="#3C3C3B"
      />
      <path
        d="M180.835 71.4001C180.835 73.7273 180.835 76.0544 180.835 78.3816C180.835 79.3456 181.617 80.1274 182.582 80.1274C183.545 80.1274 184.327 79.3456 184.327 78.3816C184.327 76.0544 184.327 73.7273 184.327 71.4001C184.327 70.436 183.545 69.6548 182.582 69.6548C181.617 69.6553 180.835 70.436 180.835 71.4001Z"
        fill="#3C3C3B"
      />
      <path
        d="M178.145 74.8726C178.145 72.5454 178.145 70.2183 178.145 67.8911C178.145 66.927 177.363 66.1453 176.4 66.1453C175.435 66.1453 174.654 66.927 174.654 67.8911C174.654 70.2183 174.654 72.5454 174.654 74.8726C174.654 75.8367 175.435 76.6184 176.4 76.6184C177.363 76.6179 178.145 75.8367 178.145 74.8726Z"
        fill="#3C3C3B"
      />
      <path
        d="M178.145 60.9082C178.145 58.581 178.145 56.2539 178.145 53.9267C178.145 52.9632 177.363 52.1814 176.4 52.1814C175.435 52.1814 174.654 52.9632 174.654 53.9267C174.654 56.2539 174.654 58.581 174.654 60.9082C174.654 61.8728 175.435 62.654 176.4 62.654C177.363 62.654 178.145 61.8728 178.145 60.9082Z"
        fill="#3C3C3B"
      />
      <path
        d="M171.964 78.3816C171.964 76.0544 171.964 73.7273 171.964 71.4001C171.964 70.436 171.182 69.6548 170.219 69.6548C169.254 69.6548 168.472 70.436 168.472 71.4001C168.472 73.7273 168.472 76.0544 168.472 78.3816C168.472 79.3456 169.254 80.1274 170.219 80.1274C171.182 80.1274 171.964 79.3456 171.964 78.3816Z"
        fill="#3C3C3B"
      />
      <path
        d="M165.783 60.9082C165.783 58.581 165.783 56.2539 165.783 53.9267C165.783 52.9632 165.001 52.1814 164.038 52.1814C163.073 52.1814 162.292 52.9632 162.292 53.9267C162.292 56.2539 162.292 58.581 162.292 60.9082C162.292 61.8728 163.073 62.654 164.038 62.654C165.001 62.654 165.783 61.8728 165.783 60.9082Z"
        fill="#3C3C3B"
      />
      <path
        d="M193.852 62.6755C191.526 62.6755 191.488 66.1147 193.814 66.1666C196.141 66.218 196.18 62.6755 193.852 62.6755Z"
        fill="#3C3C3B"
      />
      <path
        d="M170.219 62.6726C167.892 62.6732 167.853 66.1118 170.18 66.1637C172.506 66.2156 172.546 62.6732 170.219 62.6726Z"
        fill="#3C3C3B"
      />
      <path
        d="M182.581 62.6726C180.254 62.6732 180.216 66.1118 182.543 66.1637C184.869 66.2156 184.908 62.6732 182.581 62.6726Z"
        fill="#3C3C3B"
      />
      <path
        d="M176.4 45.2C174.073 45.2 174.035 48.6384 176.362 48.6904C178.688 48.7423 178.727 45.2 176.4 45.2Z"
        fill="#3C3C3B"
      />
      <path
        d="M19.8553 20C19.6747 20 19.5996 20.0751 19.5996 20.2562C19.5996 49.6856 19.5996 79.115 19.5996 108.544C19.5996 108.725 19.6747 108.8 19.8553 108.8C49.2847 108.8 78.7135 108.8 108.143 108.8C108.324 108.8 108.399 108.725 108.399 108.544C108.399 79.115 108.399 49.6856 108.399 20.2562C108.399 20.0751 108.324 20 108.143 20C78.7135 20 49.2847 20 19.8553 20Z"
        fill="#575756"
      />
      <path
        d="M107.999 108.144C107.999 108.324 107.924 108.399 107.743 108.399C78.5802 108.399 49.4179 108.399 20.2554 108.399C20.0748 108.399 19.9998 108.324 19.9998 108.144C19.9998 78.9813 19.9998 49.8183 19.9998 20.6558C19.9998 20.4752 20.0748 20.4001 20.2554 20.4001C49.4179 20.4001 78.5802 20.4001 107.743 20.4001C107.924 20.4001 107.999 20.4752 107.999 20.6558C107.999 49.8183 107.999 78.9813 107.999 108.144Z"
        fill="#E3E3E3"
      />
      <path
        d="M98.0033 98.2536C98.0033 97.9127 97.8673 97.7665 97.523 97.7665C96.5239 97.7665 95.526 97.7665 94.5275 97.7665C94.5275 97.4933 94.5275 97.2195 94.5275 96.9464C94.5275 96.3509 94.2266 95.9456 93.95 95.4833C93.0063 93.9102 92.8324 92.0888 94.7877 91.2523C96.4623 90.5349 98.325 91.7693 98.3267 93.5896C98.3267 93.7437 98.3115 93.8939 98.2788 94.0451C98.2082 94.3776 98.3194 94.5424 98.6496 94.6141C98.9826 94.6869 99.1502 94.578 99.2179 94.2438C99.8067 91.4702 96.897 89.2367 94.3378 90.4017C93.1502 90.9419 92.3555 92.1006 92.2872 93.4056C92.2517 94.0835 92.4181 94.6536 92.715 95.2479C92.925 95.6679 93.5673 96.383 93.5673 96.9469C93.5673 97.688 93.5673 98.4297 93.5673 99.1714C93.5673 99.5112 93.7079 99.6512 94.0477 99.6512C94.2221 99.6512 94.3959 99.6512 94.5703 99.6512C94.5703 99.7996 94.5703 99.9475 94.5703 100.095C94.5703 100.435 94.7109 100.575 95.0507 100.575C95.5407 100.575 96.0306 100.575 96.5205 100.575C96.8603 100.575 97.0008 100.435 97.0008 100.095C97.0008 99.9475 97.0008 99.7996 97.0008 99.6512C97.1752 99.6512 97.3491 99.6512 97.5235 99.6512C97.8633 99.6512 98.0038 99.5112 98.0038 99.1714C98.0033 98.8649 98.0033 98.559 98.0033 98.2536Z"
        fill="#575756"
      />
      <path
        d="M63.4358 29.0399C63.4358 52.6132 63.4358 76.1865 63.4358 99.7599C63.4358 100.158 63.6006 100.323 63.9991 100.323C64.3976 100.323 64.5618 100.158 64.5618 99.7599C64.5618 76.1865 64.5618 52.6132 64.5618 29.0399C64.5618 28.6414 64.3976 28.4766 63.9991 28.4766C63.6006 28.4766 63.4358 28.6414 63.4358 29.0399Z"
        fill="#B2B2B2"
      />
      <path
        d="M34.3531 98.2536C34.3531 97.9127 34.2171 97.7665 33.8728 97.7665C32.8738 97.7665 31.8758 97.7665 30.8773 97.7665C30.8773 97.4933 30.8773 97.2195 30.8773 96.9464C30.8773 96.3509 30.5764 95.9456 30.2999 95.4839C29.3561 93.9102 29.1823 92.0893 31.1375 91.2523C32.8122 90.5349 34.6743 91.7698 34.6766 93.5902C34.6766 93.7437 34.6613 93.8939 34.6286 94.0451C34.5581 94.3776 34.6692 94.5424 34.9994 94.6141C35.3325 94.6869 35.5001 94.578 35.5678 94.2438C36.1565 91.4702 33.2468 89.2367 30.6876 90.4017C29.5001 90.9419 28.7054 92.1006 28.6371 93.4056C28.6015 94.0835 28.768 94.6536 29.0649 95.2479C29.2749 95.6679 29.9172 96.383 29.9172 96.9469C29.9172 97.688 29.9172 98.4297 29.9172 99.1714C29.9172 99.5112 30.0577 99.6517 30.3975 99.6517C30.5719 99.6517 30.7458 99.6517 30.9202 99.6517C30.9202 99.7996 30.9202 99.9475 30.9202 100.095C30.9202 100.435 31.0608 100.576 31.4006 100.576C31.8905 100.576 32.3804 100.576 32.8704 100.576C33.2096 100.576 33.3507 100.435 33.3507 100.095C33.3507 99.9475 33.3507 99.7996 33.3507 99.6517C33.5251 99.6517 33.699 99.6517 33.8734 99.6517C34.2132 99.6517 34.3537 99.5112 34.3537 99.1714C34.3531 98.8649 34.3531 98.559 34.3531 98.2536Z"
        fill="#575756"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6152_23536"
          x1="176"
          y1="109.076"
          x2="176"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6152_23536"
          x1="16.5595"
          y1="63.9993"
          x2="0.308842"
          y2="63.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6152_23536"
          x1="335.441"
          y1="63.9996"
          x2="351.691"
          y2="63.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6152_23536"
          x1="288.001"
          y1="94.8799"
          x2="288.001"
          y2="33.1202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6152_23536"
          x1="288.002"
          y1="94.7471"
          x2="288.002"
          y2="85.2419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6152_23536"
          x1="288.001"
          y1="33.2523"
          x2="288.001"
          y2="42.7574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
